import React from 'react';
import { Activity } from 'lucide-react';
import styles from './ActivityFeed.module.scss';

export function ActivityFeed({ logs = [] }) {
  const hasLogs = Array.isArray(logs) && logs.length > 0;

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <h3 className={styles.title}>Recent system activity</h3>
        {!hasLogs ? (
          <span className={styles.status}>Coming soon</span>
        ) : null}
      </div>

      {hasLogs ? (
        <div className={styles.list}>
          {logs.map((log, idx) => (
            <div key={log.id ?? idx} className={styles.item}>
              {idx !== logs.length - 1 ? <div className={styles.line} aria-hidden /> : null}
              <div className={styles.dotOuter} aria-hidden>
                <div className={styles.dotInner} />
              </div>
              <div className={styles.body}>
                <div className={styles.metaRow}>
                  <span className={styles.time}>{log.time}</span>
                  <span className={styles.system}>{log.systemName}</span>
                </div>
                <p className={styles.message}>{log.message}</p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.emptyState}>
          <div className={styles.emptyIconRow}>
            <span className={styles.emptyIconWrap} aria-hidden>
              <Activity size={18} strokeWidth={2} />
            </span>
            <span className={styles.emptyEyebrow}>Coming soon</span>
          </div>
          <p className={styles.emptyLead}>
            A chronological view of runs, errors, and integrations will appear here.
          </p>
          
        </div>
      )}
    </div>
  );
}
